import Loader from '@jetbrains/ring-ui/components/loader-inline/loader-inline'
import type {PopupAttrs} from '@jetbrains/ring-ui/components/popup/popup'
import compose from 'lodash/flowRight'
import {connect} from 'react-redux'

import Popup from '../components/common/Popup/Popup.lazy'
import QueuedBuildInfo from '../components/common/QueuedBuildInfo/QueuedBuildInfo.container'
import {withBranchProps} from '../hooks/routes'
import type {State} from '../reducers/types'
import {getHistoryLocator} from '../rest/locators'
import {getBuildsData} from '../selectors'
import type {Branch} from '../services/rest'
import {stringifyId} from '../types'
import type {BuildId, BuildTypeId} from '../types'

import BuildsFetcher from './BuildsFetcher'

const loader = <Loader>{'Loading...'}</Loader>
type OwnProps = PopupAttrs & {
  buildTypeId: BuildTypeId
}
type ReduxOwnProps = OwnProps & {
  branch?: Branch
}
type StateProps = {
  locator: string
  buildIds: ReadonlyArray<BuildId>
  ready: boolean
}
type Props = ReduxOwnProps & StateProps

function QueuedBuildsPopup({buildTypeId, branch, locator, buildIds, ready, ...restProps}: Props) {
  return (
    <Popup {...restProps}>
      <BuildsFetcher buildTypeId={buildTypeId} withQueued locator={locator}>
        {ready
          ? buildIds.map(id => <QueuedBuildInfo key={stringifyId(id)} buildId={id} />)
          : loader}
      </BuildsFetcher>
    </Popup>
  )
}

export default compose(
  withBranchProps,
  connect((state: State, {buildTypeId, branch}: ReduxOwnProps): StateProps => {
    const locator = getHistoryLocator({
      buildTypeId,
      branch,
      buildState: 'queued',
    })
    const {data, ready} = getBuildsData(state, locator)
    return {
      locator,
      buildIds: data,
      ready,
    }
  }),
)(QueuedBuildsPopup)
